import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {Heart} from "lucide-react";
import {get} from 'lodash';
import React from 'react';
import {useTranslation} from "react-i18next";
import {convertUrl, parseUrl} from "common/helpers";
import {color, font, radius, type} from "common/tokens";
import {useSetTranslation} from "common/useSetTranslation";
import Card from "components/redesign/Card";
import ShimmerImage from "components/redesign/ShimmerImage";

const useStyles = makeStyles({
  post: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 16,
  },
  thumbnail: {
    width: '100%',
    height: 132,
    borderRadius: radius.CONTROL,
  },
  body: {
    minWidth: 0,
  },
  source: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_SUBTLE,
    textDecoration: 'none',
    display: 'block',
  },
  title: {
    ...type.sessionTitle,
    color: color.TEXT,
    textDecoration: 'none',
    display: 'block',
    margin: '6px 0 0',
  },
  curated: {
    ...type.meta,
    color: color.ACCENT_TEXT,
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: 6,
  },
  description: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    margin: '8px 0 0',
  },
  like: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    marginTop: 14,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    color: color.TEXT_SUBTLE,
  },
  liked: {
    color: color.ACCENT,
  },
  likeCount: {
    ...type.label,
  },
});

const DefaultPost = ({post, toggleLike, onClickCount}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const {st} = useSetTranslation();

  const {feedLikes, isLiked, id} = post;
  const {thumbnail, description, localeDescription, link, title, localeTitle, mtCuratedNote} =
    get(post, 'contentObject');

  const linkHost = get(parseUrl(link), 'hostname', '');

  return (
    <Card variant={'media'} className={classes.post}>
      {Boolean(thumbnail) && <ShimmerImage src={convertUrl(thumbnail)} className={classes.thumbnail}/>}
      <div className={classes.body}>
        <a href={link} onClick={() => onClickCount(id)} target={'_blank'} rel={'noreferrer'}
           className={classes.source}>{linkHost}</a>
        <a href={link} onClick={() => onClickCount(id)} target={'_blank'} rel={'noreferrer'}
           className={classes.title}>{st(title, localeTitle)}</a>
        {mtCuratedNote && (
          <a href={link} target={'_blank'} rel={'noreferrer'} className={classes.curated}>
            {t('fromMentorTogetherTeam')}
          </a>
        )}
        <p className={classes.description}>{st(description, localeDescription)}</p>
        <button
          type={'button'}
          onClick={() => toggleLike(id)}
          className={classNames(classes.like, isLiked && classes.liked)}
        >
          <Heart size={15} fill={isLiked ? 'currentColor' : 'transparent'}/>
          <span className={classes.likeCount}>{feedLikes === 0 ? '' : feedLikes}</span>
        </button>
      </div>
    </Card>
  );
};

export default DefaultPost;
